import { NgModule, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ShopRoutingModule } from './shop-routing.module';
import { LucideAngularModule, icons } from 'lucide-angular';
import { Interceptor } from 'src/app/services/interceptor/interceptor.interceptor';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ElementsModule } from 'src/app/shared/elements/elements.module';
import { StrategicProcurementComponent } from './strategic-procurement/strategic-procurement.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { LoginPopupComponent } from './login-popup/login-popup.component';
import { IndirectMaterialDetailComponent } from './indirect-material-detail/indirect-material-detail.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ThankYouComponent } from './thank-you/thank-you.component';
@NgModule({
  declarations: [
    LandingPageComponent,
    StrategicProcurementComponent,
    CheckoutComponent,
    LoginPopupComponent,
    IndirectMaterialDetailComponent,
   // SortByOrderPipe,
    ThankYouComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    ShopRoutingModule,
    InfiniteScrollModule,
    ElementsModule,
    LucideAngularModule.pick(icons),
    SlickCarouselModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true
    }
  ],
})
export class ShopModule {
  constructor(private injector: Injector) {  }
 }
